import React from 'react';
import { connect } from 'react-redux';
import Button from '../Toolbar/Button';
import { thicknessOptions } from './thicknessOptions';
import {
  setToolbarOptionsPanel,
  updateThickness,
} from '../../../../redux/actions/canvas_editor';
import styles from './Thickness.scss';
import OptionsPanel from '../OptionsPanel/OptionsPanel';

import { setObjectThickness } from '../../helpers/fabricHelpers';

import { __ } from '../../../../core/utils';

function Thickness({
  canvas_editor: {
    selectedThickness,
    toolbarOptionsPanel,
    fabricCanvases,
    activeTool,
  },
}) {
  const isOptionsOpen = toolbarOptionsPanel === 'thickness';

  const restoreTextboxEditing = (canvas, obj) => {
    requestAnimationFrame(() => {
      if (!canvas || !obj) return;
      if (!canvas.getObjects().includes(obj)) return;

      canvas.setActiveObject(obj);

      if (!obj.isEditing && obj.editable) {
        obj.enterEditing();
      }

      obj.hiddenTextarea?.focus();
      canvas.requestRenderAll();
    });
  };

  const applyThicknessToActiveObject = (thickness) => {
    if (!fabricCanvases) return;

    Object.entries(fabricCanvases).forEach(([pageNumber, canvas]) => {
      const obj = canvas.getActiveObject();
      if (!obj) return;
      const shouldRestoreEditing =
        activeTool === 'textbox' && obj.objectType === 'textbox';

      setObjectThickness(obj, thickness.key);
      canvas.requestRenderAll();

      canvas.fire('object:modified', { target: obj, source: 'toolbar' });

      if (shouldRestoreEditing) {
        restoreTextboxEditing(canvas, obj);
      }
    });
  };

  const toggleOptions = () => {
    setToolbarOptionsPanel(isOptionsOpen ? '' : 'thickness');
  };

  const handleThicknessSelect = (sizeKey) => {
    const findThickness = thicknessOptions.find((opt) => opt.key === sizeKey);

    updateThickness(findThickness);
    setToolbarOptionsPanel(isOptionsOpen ? '' : 'thickness');

    applyThicknessToActiveObject(findThickness);
  };

  return (
    <div className={styles.wrapper}>
      <Button
        label={__('canvas.toolbar.thickness.' + selectedThickness?.key)}
        id={selectedThickness?.key}
        icon={selectedThickness?.icon}
        onClick={toggleOptions}
        extraClass={
          isOptionsOpen
            ? ['withBadge', 'withMarginBottom']
            : ['withBadge', 'withSpacer']
        }
      />

      {isOptionsOpen && (
        <OptionsPanel
          options={_.map(thicknessOptions, (thickness) => ({
            ...thickness,
            label: __('canvas.toolbar.thickness.' + thickness?.key),
          }))}
          value={selectedThickness.key}
          setValue={handleThicknessSelect}
          customStyles={styles.optionsPanel}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  canvas_editor: state.canvas_editor,
});

export default connect(mapStateToProps)(Thickness);
